import { useRef, useCallback } from "react";
import type { Dispatch, SetStateAction } from "react";
import type {
  TModalProps
} from "@app/dashboard/types/innerLayout/checkout_customization/payment-methods";

export const useConfirm = (setModalProps: Dispatch<SetStateAction<TModalProps>>) => {
  const resolverRef = useRef<((value: boolean) => void) | null>(null);

  const confirmationInquiry = useCallback((): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
      resolverRef.current = resolve;
      setModalProps(prev => ({ ...prev, open: true }));
    });
  }, [setModalProps]);

  const handleConfirm = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(true);
      setModalProps(prev => ({ ...prev, open: false }));
      resolverRef.current = null;
    }
  }, [setModalProps]);

  const handleCancel = useCallback(() => {
    if (resolverRef.current) {
      resolverRef.current(false);
      setModalProps(prev => ({ ...prev, open: false }));
      resolverRef.current = null;
    }
  }, [setModalProps]);

  return {
    confirmationInquiry,
    handleConfirm,
    handleCancel,
  };
};